import { PaginatedVacationDaysQueryVariables } from "@/graphql/__generated__/graphql";
import DateRangeFilter from "../../Shared/DateRangeFilter";
import { format } from "date-fns";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedVacationDaysQueryVariables) => void;
}

/**
 * VacationDaysDateRange component for filtering vacation days by date range
 * @param props Component properties
 * @returns JSX element
 */
function VacationDaysDateRange({ displayAmount, handleSubmitClick }: Props) {
  const vacationDaysDateConfig = {
    paginationStateKey: "paginatedVacationDays" as keyof PaginationState,
    dateFieldName: "activeFrom",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      dateRange: { gte: Date | null; lte: Date | null },
      sort?: any
    ): PaginatedVacationDaysQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: (dateRange.gte === null && dateRange.lte === null) ? null : {
          gte: dateRange.gte ? format(dateRange.gte, "yyyy-MM-dd") + "T00:00:00+00:00" : null,
          lte: dateRange.lte ? format(dateRange.lte, "yyyy-MM-dd") + "T23:59:59+00:00" : null,
        },
        days: filters.days || null,
        lengthOfEmployment: filters.lengthOfEmployment || null,
        provinces: filters.provinces || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      days: paginationState.filters?.days,
      lengthOfEmployment: paginationState.filters?.lengthOfEmployment,
      provinces: paginationState.filters?.provinces,
    })
  };

  return (
    <DateRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={vacationDaysDateConfig}
    />
  );
}

export default VacationDaysDateRange;
